import { getPayrollRuns, runPayroll } from '../api';
import { dispatchErrorAction } from './index';
import { getPagesCount } from '../helpers/general';
import { GET_PAYROLL_RUNS_SUCCESS } from './actionTypes';
import { PAYROLL_RUNS_LIST_PAGE_SIZE } from '../constants/general';
import { errorCodes } from '../constants/errorCodes';

export function getPayrollList (skip = 0) {
  return dispatch => getPayrollRuns(skip)
    .then(({ data }) => {
      const pagesQuantity = getPagesCount(data.count, PAYROLL_RUNS_LIST_PAGE_SIZE);
      dispatch({ type: GET_PAYROLL_RUNS_SUCCESS, payrollRuns: data.data, pagesQuantity });
      return { data: data.data, pagesQuantity };
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function generatePayroll (date) {
  return dispatch => runPayroll(date)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response && error.response.data.error.code === errorCodes.nonApprovedJobsExist) {
        return error.response.data;
      }

      dispatchErrorAction(error, dispatch);
    });
}



// WEBPACK FOOTER //
// ./src/actions/payroll.js